import React, { Component } from 'react';
import classes from './Controls.css';
import arrowBack from '../../img/arrowBack.svg';
import arrowForth from '../../img/arrowForth.svg';
import arrowDown from '../../img/chevron-down-solid.svg';
import arrowUp from '../../img/chevron-up-solid.svg';
import infinitySolid from '../../img/infinity-solid.svg';
import randomSolid from '../../img/random-solid.svg';
import Wrapper from '../../hoc/Wrapper/Wrapper';

class Controls extends Component {

    render() {
        let controlsClasses = [classes.Controls, classes.Closed];
        if (this.props.open) {
            controlsClasses = [classes.Controls, classes.Open];
        }
        return (
            <Wrapper>
                {window.innerWidth < 769 && this.props.open &&
                <div
                    className={classes.Backdrop}
                    onClick={this.props.toggleControls}
                    >
                </div>}
                <aside className={controlsClasses.join(' ')} onClick={this.props.onClick}>
                    {/*<div className={classes.buttonGroup}>*/}
                    {/*    <div className={classes.buttonHeader}>Фон</div>*/}
                    {/*    <button*/}
                    {/*        className={[classes.button, classes.SwitchBtn].join(' ')}*/}
                    {/*        onClick={this.props.choosePrevBackground}*/}
                    {/*        style={{backgroundImage: `url(${arrowBack})`}}>*/}
                    {/*    </button>*/}
                    {/*    <button*/}
                    {/*        className={[classes.button, classes.SwitchBtn].join(' ')}*/}
                    {/*        onClick={this.props.chooseNextBackground}*/}
                    {/*        style={{backgroundImage: `url(${arrowForth})`}}>*/}
                    {/*    </button>*/}
                    {/*</div>*/}
                  <div className={classes.buttonGroup}>
                    <div className={classes.buttonHeader}>Волосы</div>
                    <button
                      className={[classes.button, classes.SwitchBtn].join(' ')}
                      onClick={this.props.chooseClothes}
                      data-direction="prev"
                      data-clothing="heads"
                      style={ window.innerWidth > 1024 ? {backgroundImage: `url(${arrowBack})`} : {backgroundImage: `url(${arrowUp})`} }
                      >
                    </button>
                    <button
                      className={[classes.button, classes.SwitchBtn].join(' ')}
                      onClick={this.props.chooseClothes}
                      data-direction="rand"
                      data-clothing="heads"
                      style={{backgroundImage: `url(${randomSolid})`}}>
                    </button>
                    <button
                      className={[classes.button, classes.SwitchBtn].join(' ')}
                      onClick={this.props.chooseClothes}
                      data-direction="next"
                      data-clothing="heads"
                      style={ window.innerWidth > 1024 ? {backgroundImage: `url(${arrowForth})`} : {backgroundImage: `url(${arrowDown})`} }
                    >
                    </button>
                  </div>
                  <div className={classes.buttonGroup}>
                    <div className={classes.buttonHeader}>Верх</div>
                    <button
                      className={[classes.button, classes.SwitchBtn].join(' ')}
                      onClick={this.props.chooseClothes}
                      data-direction="prev"
                      data-clothing="shirt"
                      style={ window.innerWidth > 1024 ? {backgroundImage: `url(${arrowBack})`} : {backgroundImage: `url(${arrowUp})`} }>
                    </button>
                    <button
                      className={[classes.button, classes.SwitchBtn].join(' ')}
                      onClick={this.props.chooseClothes}
                      data-direction="rand"
                      data-clothing="shirt"
                      style={{backgroundImage: `url(${randomSolid})`}}>
                    </button>
                    <button
                      className={[classes.button, classes.SwitchBtn].join(' ')}
                      onClick={this.props.chooseClothes}
                      data-direction="next"
                      data-clothing="shirt"
                      style={ window.innerWidth > 1024 ? {backgroundImage: `url(${arrowForth})`} : {backgroundImage: `url(${arrowDown})`} }>
                    </button>
                  </div>
                  <div className={classes.buttonGroup}>
                    <div className={classes.buttonHeader}>Низ</div>
                    <button
                      className={[classes.button, classes.SwitchBtn].join(' ')}
                      onClick={this.props.chooseClothes}
                      data-direction="prev"
                      data-clothing="pants"
                      style={ window.innerWidth > 1024 ? {backgroundImage: `url(${arrowBack})`} : {backgroundImage: `url(${arrowUp})`} }>
                    </button>
                    <button
                      className={[classes.button, classes.SwitchBtn].join(' ')}
                      onClick={this.props.chooseClothes}
                      data-direction="rand"
                      data-clothing="pants"
                      style={{backgroundImage: `url(${randomSolid})`}}>
                    </button>
                    <button
                      className={[classes.button, classes.SwitchBtn].join(' ')}
                      onClick={this.props.chooseClothes}
                      data-direction="next"
                      data-clothing="pants"
                      style={ window.innerWidth > 1024 ? {backgroundImage: `url(${arrowForth})`} : {backgroundImage: `url(${arrowDown})`} }>
                    </button>
                  </div>
                  <div className={classes.buttonGroup}>
                    <div className={classes.buttonHeader}>Обувь</div>
                    <button
                      className={[classes.button, classes.SwitchBtn].join(' ')}
                      onClick={this.props.chooseClothes}
                      data-direction="prev"
                      data-clothing="shoes"
                      style={ window.innerWidth > 1024 ? {backgroundImage: `url(${arrowBack})`} : {backgroundImage: `url(${arrowUp})`} }>
                    </button>
                    <button
                      className={[classes.button, classes.SwitchBtn].join(' ')}
                      onClick={this.props.chooseClothes}
                      data-direction="rand"
                      data-clothing="shoes"
                      style={{backgroundImage: `url(${randomSolid})`}}>
                    </button>
                    <button
                      className={[classes.button, classes.SwitchBtn].join(' ')}
                      onClick={this.props.chooseClothes}
                      data-direction="next"
                      data-clothing="shoes"
                      style={ window.innerWidth > 1024 ? {backgroundImage: `url(${arrowForth})`} : {backgroundImage: `url(${arrowDown})`} }>
                    </button>
                  </div>
                  <div className={classes.buttonGroup}>
                    <div className={classes.buttonHeader}>Сумка</div>
                    <button
                      className={[classes.button, classes.SwitchBtn].join(' ')}
                      onClick={this.props.chooseClothes}
                      data-direction="prev"
                      data-clothing="accessorius"
                      style={ window.innerWidth > 1024 ? {backgroundImage: `url(${arrowBack})`} : {backgroundImage: `url(${arrowUp})`} }>
                    </button>
                    <button
                      className={[classes.button, classes.SwitchBtn].join(' ')}
                      onClick={this.props.chooseClothes}
                      data-direction="rand"
                      data-clothing="accessorius"
                      style={{backgroundImage: `url(${randomSolid})`}}>
                    </button>
                    <button
                      className={[classes.button, classes.SwitchBtn].join(' ')}
                      onClick={this.props.chooseClothes}
                      data-direction="next"
                      data-clothing="accessorius"
                      style={ window.innerWidth > 1024 ? {backgroundImage: `url(${arrowForth})`} : {backgroundImage: `url(${arrowDown})`} }>
                    </button>
                  </div>
                    {/*<div className={[classes.buttonGroup, classes.colorButtons].join(' ')}>*/}
                    {/*    <div className={[classes.buttonHeader, classes.giftButtonHeader].join(' ')} onClick={this.props.toggleShowGiftPalette} style={{cursor: 'pointer'}}>Добавить подарок</div>*/}
                    {/*    <button*/}
                    {/*      className={[classes.button, classes.SwitchBtn, classes.colorBtn, classes.giftButton].join(' ')}*/}
                    {/*      onClick={this.props.toggleShowGiftPalette}*/}
                    {/*      style={{backgroundImage: `url(${arrowForth})`}}>*/}
                    {/*    </button>*/}
                    {/*  {this.props.showGiftPalette && <div className={[classes.paletteBlock, classes.giftsBlock].join(' ')}>*/}
                    {/*    {this.props.clothesList.map(gift=> {*/}
                    {/*      return <span key={gift.name} id={gift.name} style={{backgroundImage: `url(${gift.url})`, backgroundSize: 'contain'}} onClick={(e) => this.props.addGift(e,gift.name)}>{gift.rusname}</span>*/}
                    {/*    })}*/}
                    {/*  </div>}*/}
                    {/*</div>*/}
                    <div className={[classes.buttonGroup, classes.oneHalf].join(' ')}>
                        {/*<div className={classes.buttonHeader}>Добавить фотографию</div>*/}
                        <input type="file" id="loadAvatar" className={classes.fileInput} onChange={(e) => this.props.onFileInputChange(e)}/>
                        <label htmlFor="loadAvatar" className={classes.button}>Загрузить фото</label>
                    </div>
                    <div className={[classes.buttonGroup, classes.oneHalf].join(' ')}>
                        <button
                          className={[classes.button, classes.js_randomize].join(' ')}
                          onClick={this.props.randomize}
                          style={{backgroundColor: '#dc0623', borderColor: '#dc0623'}}
                          data-direction="rand"
                          data-clothing="every"
                        >Случайный выбор</button>
                    </div>
                    {/*<div className={classes.buttonGroup}>*/}
                    {/*    <button className={[classes.button, classes.js_randomize].join(' ')} onClick={this.props.addText}>Добавить текст</button>*/}
                    {/*</div>*/}
                  {/*<div className={[classes.buttonGroup, classes.oneHalf].join(' ')}>*/}
                  {/*  <input id="foto-bg" type="checkbox" className={[classes.photoBg]} checked={this.props.photoHidden} onClick={this.props.togglePhotoAndBG} />*/}
                  {/*  <label htmlFor="foto-bg">Спрятать фото за фон</label>*/}
                  {/*</div>*/}
                  {/*<div className={[classes.fontDecorationBlock, this.props.currentTextSet.unit !== null && classes.show].join(' ')}>*/}
                  {/*      <div className={classes.inputGroup}>*/}
                  {/*          <label htmlFor="text"></label>*/}
                  {/*          <input type="text" value={this.props.currentTextSet.value} className={classes.textInput} placeholder="Введите текст" onChange={(e) => this.props.findTextAndSetProps(e, "value")}/>*/}
                  {/*      </div>*/}
                  {/*      <div className={classes.buttonHeader}>Размер шрифта</div>*/}

                  {/*      <div className={classes.Switchgroup}>*/}
                  {/*          <button*/}
                  {/*            className={[classes.button, classes.SwitchBtn].join(' ')}*/}
                  {/*            onClick={() => this.props.findTextAndSetProps(false, "size")}*/}
                  {/*            style={{backgroundImage: `url(${arrowBack})`}}>*/}
                  {/*          </button>*/}
                  {/*          <span>{this.props.currentTextSet.size}</span>*/}
                  {/*          <button*/}
                  {/*            className={[classes.button, classes.SwitchBtn].join(' ')}*/}
                  {/*            onClick={() => this.props.findTextAndSetProps(true, "size")}*/}
                  {/*            style={{backgroundImage: `url(${arrowForth})`}}>*/}
                  {/*          </button>*/}
                  {/*      </div>*/}
                  {/*      <div className={[classes.buttonGroup, classes.colorButtons].join(' ')}>*/}
                  {/*          <div className={classes.buttonHeader}>Цвет текста</div>*/}
                  {/*          <div className={[classes.textInput, classes.colorInput].join(' ')} style={{backgroundColor: this.props.currentTextSet.color, cursor: 'pointer'}} onClick={this.props.toggleShowPalette}></div>*/}
                  {/*          <button*/}
                  {/*            className={[classes.button, classes.SwitchBtn, classes.colorBtn].join(' ')}*/}
                  {/*            onClick={this.props.toggleShowPalette}*/}
                  {/*            style={{backgroundImage: `url(${arrowForth})`}}>*/}
                  {/*          </button>*/}
                  {/*        {this.props.showPalette && <div className={classes.paletteBlock}>*/}
                  {/*          {this.props.palette.map(color=> {*/}
                  {/*            return <span key={color} id={color} style={{backgroundColor: color}} onClick={(e) => this.props.findTextAndSetProps(e, "color")}></span>*/}
                  {/*          })}*/}
                  {/*        </div>}*/}

                  {/*      </div>*/}
                  {/*      <div className={classes.Switchgroup}>*/}
                  {/*          <div className={classes.buttonHeader}>Начертание</div>*/}
                  {/*          <button*/}
                  {/*            className={[classes.button, classes.SwitchBtn].join(' ')}*/}
                  {/*            onClick={() => this.props.findTextAndSetProps(false, "family")}*/}
                  {/*            style={{backgroundImage: `url(${arrowBack})`}}>*/}
                  {/*          </button>*/}
                  {/*          <span style={{fontFamily: this.props.currentTextSet.family}}>{this.props.currentTextSet.family.slice(0, this.props.currentTextSet.family.indexOf(','))}</span>*/}
                  {/*          <button*/}
                  {/*            className={[classes.button, classes.SwitchBtn].join(' ')}*/}
                  {/*            onClick={() => this.props.findTextAndSetProps(true, "family")}*/}
                  {/*            style={{backgroundImage: `url(${arrowForth})`}}>*/}
                  {/*          </button>*/}
                  {/*      </div>*/}
                  {/*      <div className={classes.buttonGroup}>*/}
                  {/*          <div className={classes.buttonHeader}>Оформление текста</div>*/}
                  {/*          <button*/}
                  {/*            className={[classes.button, classes.button_style, !this.props.italic && classes.button_style_unpressed].join(' ')}*/}
                  {/*            onClick={() => this.props.findTextAndSetProps(true, "italic")}*/}
                  {/*            style={{fontStyle: 'italic'}}*/}
                  {/*            >i*/}
                  {/*          </button>*/}
                  {/*          <button*/}
                  {/*            className={[classes.button, classes.button_style, !this.props.bold && classes.button_style_unpressed].join(' ')}*/}
                  {/*            onClick={() => this.props.findTextAndSetProps(true, "bold")}*/}
                  {/*            style={{fontWeight: 'bold'}}*/}
                  {/*          >b*/}
                  {/*          </button>*/}
                  {/*          <button*/}
                  {/*            className={[classes.button, classes.button_style, !this.props.underline && classes.button_style_unpressed].join(' ')}*/}
                  {/*            onClick={() => this.props.findTextAndSetProps(true, "underline")}*/}
                  {/*            style={{textDecoration: 'underline'}}*/}
                  {/*          >u*/}
                  {/*          >u*/}
                  {/*          </button>*/}
                  {/*      </div>*/}
                  {/*  </div>*/}
                  {this.props.token &&
                  <div className={[classes.buttonGroup, classes.oneHalf].join(' ')}>
                    <button className={[classes.button, classes.js_sendToServer].join(' ')}
                            onClick={this.props.sendToServer}>Отправить на конкурс
                    </button>
                  </div>
                  }
                    <div className={[classes.buttonGroup, classes.oneHalf].join(' ')}>
                        <button  className={[classes.button, classes.js_saveStage].join(' ')} onClick={this.props.onStageSave}>Сохранить открытку</button>
                    </div>
                    <div className={[classes.buttonGroup, classes.oneHalf, classes.backToKarusel].join(' ')}>
                      <a href="https://www.karusel-tv.ru/contest/CapsuleChix" className={[classes.button, classes.back].join(' ')}>На главную конкурса</a>
                    </div>
                </aside>
            </Wrapper>
        );
    }
}
export default Controls;



// WEBPACK FOOTER //
// ./src/components/Controls/Controls.js